export default {
    location: "Location",
    marking: "Marking",
    markingList: 'Marking List',
    markings: 'Markings',
    customerMarkings: 'Customer Markings',

    supplierName: 'Supplier Name',
    supplierContact: 'Supplier Contact',
    purchaseOrderNo: 'PO No.',
    supplierPurchaseNo: "Supplier PO No.",
    courierNo: "Courier Tracking No",
    handleQty: 'Handle Qty',
    pcsCtn: 'Pcs/Ctn',
    packUnit: 'Pack Unit',
    cbm: 'Cbm',
    tValue: 'TValue',
    tCbm: 'TCbm',
    tWeight: 'TWeight',
    code: 'Code',

    loaded: 'Loaded',
    pending: 'Pending',

    action: `Action`,

    systemId: 'SysId',
    split: `Split`,
    splitId: `SplitId`,
    yes: 'Yes',
    no: 'No',
    isSplit: `Is Split`,
    notSplit: `Not Split`,

    delete: "Delete"
}